function formatAmount(n) {
  return n ? parseFloat(n).toFixed(2).replace(/./g,
    function (c, i, a) {
      return i && c !== "." && ((a.length - i) % 3 === 0) ? ',' + c : c;
    }) : '0.00';
}

function defaultCurrencyCode (code) {
  return code ?
  {
    symbol : code,
    left : false
  } :
  {
    symbol : '£',
    left : true
  }
}

const currencyCodeLibrary = {
  GBP : {
    symbol : '£',
    left : true
  },
  USD : {
    symbol : '$',
    left : true
  },
  EUR : {
    symbol : '€',
    left : true
  },
  ZAR : {
    symbol : 'R',
    left : true
  }
};

export function formatCurrency(amount, currencyCode) {
  const formattedAmount = formatAmount(amount);
  const currencyObject = currencyCodeLibrary[currencyCode] || defaultCurrencyCode(currencyCode);

  return currencyObject.left ? currencyObject.symbol + formattedAmount : formattedAmount + ' ' + currencyObject.symbol;
}

export function convertCurrencyString(currencyString) {
  if (!currencyString) {
      return null;
  }
  var values = currencyString.split(",");

  values = values.map(function(value) {
      const [amount, currencyCode] = value.split(" ");
      return formatCurrency(amount, currencyCode);
  });

  return values.join(", ");
}



// WEBPACK FOOTER //
// ./utils/CurrencyFormatting.js